import { apiUrl, performApiRequest } from '@/infrastructure/api-requests';
import { CorrectAddressesCommand, GetInvalidAddressesQuery, GetInvalidAddressQuery, InvalidAddress } from './types';

// -- Queries

export function getInvalidAddresses(query: GetInvalidAddressesQuery): Promise<InvalidAddress[]> {
  const url = `${apiUrl}/api/address-correction/get-invalid-addresses-query`;
  return performApiRequest<InvalidAddress[]>({ url, method: 'POST', data: query });
}

export function getInvalidAddress(query: GetInvalidAddressQuery): Promise<InvalidAddress> {
  const url = `${apiUrl}/api/address-correction/get-invalid-address-query`;
  return performApiRequest<InvalidAddress>({ url, method: 'POST', data: query });
}

// -- Commands

export function correctAddresses(command: CorrectAddressesCommand): Promise<void> {
  const url = `${apiUrl}/api/address-correction/correct-addresses-command`;
  return performApiRequest<void>({ url, method: 'POST', data: command });
}
